<template>
  <div class="full-height full-width row">
    <q-drawer
      v-model="state.left.show"
      :mini="!state.left.show || state.left.miniState"
      :width="220"
      :breakpoint="500"
      bordered
      content-class="bg-white column"
    >
      <q-scroll-area class="col">
        <q-list padding>
          <q-item v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label>Media Solution</q-item-label>
              <q-item-label caption style="padding-bottom:8px">
                라이브와 스트리밍에 관한 솔루션 입니다.<br />
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-separator v-show="state.left.miniState == false" />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                테스트
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item :active="state.page.value == 'face-mesh-view'" clickable v-ripple @click="state.page.value = 'face-mesh-view'">
            <q-item-section avatar>
              <q-icon name="face" />
            </q-item-section>

            <q-item-section>
              Face Mesh
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Face Mesh</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'pose-estimation-view'" clickable v-ripple @click="state.page.value = 'pose-estimation-view'">
            <q-item-section avatar>
              <q-icon name="accessibility" />
            </q-item-section>

            <q-item-section>
              Pose Estimation
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Pose Estimation</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'selfie-view'" clickable v-ripple @click="state.page.value = 'selfie-view'">
            <q-item-section avatar>
              <q-icon name="description" />
            </q-item-section>

            <q-item-section>
              Selfie Segmentation
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Selfie Segmentation</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'hair-view'" clickable v-ripple @click="state.page.value = 'hair-view'">
            <q-item-section avatar>
              <q-icon name="description" />
            </q-item-section>

            <q-item-section>
              Hair Segmentation
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Hair Segmentation</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'hands-view'" clickable v-ripple @click="state.page.value = 'hands-view'">
            <q-item-section avatar>
              <q-icon name="pan_tool" />
            </q-item-section>

            <q-item-section>
              Hands
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Hands</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'object-detection-view'" clickable v-ripple @click="state.page.value = 'object-detection-view'">
            <q-item-section avatar>
              <q-icon name="crop_free" />
            </q-item-section>

            <q-item-section>
              Object Detection
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Object Detection</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'iris-view'" clickable v-ripple @click="state.page.value = 'iris-view'">
            <q-item-section avatar>
              <q-icon name="remove_red_eye" />
            </q-item-section>

            <q-item-section>
              Iris
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Iris</q-tooltip>
          </q-item>
        </q-list>
      </q-scroll-area>
      <q-separator />
      <q-item clickable v-ripple @click="state.left.miniState = !state.left.miniState">
        <q-item-section avatar>
          <q-icon v-if="state.left.miniState == false" name="chevron_left" />
          <q-icon v-else name="chevron_right" />
        </q-item-section>

        <q-item-section style="color:rgb(125, 125, 125);font-size:12px;">
          POWERED BY SELVAS AI
        </q-item-section>
      </q-item>
    </q-drawer>

    <q-page-container class="column col full-height full-width">
      <q-page class="column col full-height full-width" style="background:rgb(237, 238, 242);overflow:auto;">
        <face-mesh-view v-if="state.page.value == 'face-mesh-view'"
          ref='face-mesh-view'
          :recognition-type="'face-mesh'"
        />
        <face-mesh-view v-if="state.page.value == 'pose-estimation-view'"
          ref='pose-estimation-view'
          :recognition-type="'pose-estimation'"
        />
        <face-mesh-view v-if="state.page.value == 'selfie-view'"
          ref='selfie-view'
          :recognition-type="'selfie-segmentation'"
        />
        <face-mesh-view v-if="state.page.value == 'hair-view'"
          ref='hair-view'
          :recognition-type="'hair-segmentation'"
        />
        <face-mesh-view v-if="state.page.value == 'hands-view'"
          ref='hands-view'
          :recognition-type="'hands'"
        />
        <face-mesh-view v-if="state.page.value == 'object-detection-view'"
          ref='object-detection-view'
          :recognition-type="'object-detection'"
        />
        <face-mesh-view v-if="state.page.value == 'iris-view'"
          ref='iris-view'
          :recognition-type="'iris'"
        />
      </q-page>
    </q-page-container>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import FaceMeshView from '@/projects/media/views/FaceMeshView.vue'


export default {
  name: 'App',
  data: function () {
    return {
      state: {
        left: {
          show: true,
          miniState: false
        },
        page: {
          value: 'face-mesh-view'
        }
      }
    }
  },
  components: {
    FaceMeshView
  },
  methods: {
  }
}
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
}

.body {
  display:flex;
  flex-direction:column;
  height:100%;
  width:100%;
  background: rgb(237, 238, 241);
}

.q-toggle__thumb {
  color: red !important;
}

.q-toggle__thumb:after {
  background: rgb(230, 230, 230) !important;
}

.q-toggle__inner--indet .q-toggle__thumb:after {
  background: rgb(3, 169, 244) !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background: #027BE3 !important;
}

.q-toggle__inner.q-toggle__inner--indet {
  color:rgb(41, 182, 246);
}

::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 6px;
  height: 6px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
}

</style>
